import React from "react";

import LogoProyecto from "./../../UI/Logos/logo-proyecto.svg";

interface Props {
  isLoading: boolean;
  isWelcome: boolean;
  handleHideWelcome: any;
}

interface State {}

class WelcomeScreen extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className={
          this.props.isLoading || this.props.isWelcome
            ? "welcome-container fade-out"
            : "welcome-container fade-in"
        }
      >
        <div className="logo-proyecto-container">
          <img src={LogoProyecto} alt="" />
        </div>
        <div className="text-container">
          <div className="legal-text">
            Las imágenes contenidas en este documento, así como el mobiliario,
            electrodomésticos acabados y demás elementos accesorios que aparecen
            en las mismas son una representación ilustrativa del Proyecto y no
            comprometen contractualmente la responsabilidad de la Constructora,
            quien se reserva el derecho de realizar modificaciones al Proyecto
            en cualquier momento. Las disponibilidades, áreas, calidad y demás
            elementos que se incluyen en las piezas publicitarias podrán tener
            variaciones posteriores a su publicación; por tanto, es necesario
            corroborar todos los datos en la Sala de Negocios, previo a
            suscribir un contrato de vinculación al Proyecto Inmobiliario
          </div>
        </div>
        <div
          className="btn-ingreso"
          onClick={() => {
            this.props.handleHideWelcome();
          }}
        >
          Ingresar
        </div>
      </div>
    );
  }
}

export default WelcomeScreen;
